const taskMock = [
    {
        type: 'feature',
        description: 'add material ui library to project',
        timeToDo: 2,
    },
];

export default taskMock;